import '../../../common/dashboard/filters/filter.js.coffee'

Namespace 'CustomerVisualMode.Filters'

class CustomerVisualMode.Filters.DateFilter extends Common.Dashboard.Filters.Filter

  @FILTER_TYPE: 'date'
  @TYPES:
    ALL_HISTORY: 'all_history'
    CURRENT_DAY: 'current_day'
    LAST_INTERVAL: 'last_interval'
    DATE_RANGE: 'date_range'
    DATE_RANGE_UNTIL_NOW: 'date_range_until_now'
  @REALTIME_TYPES: [@TYPES.LAST_INTERVAL, @TYPES.ALL_HISTORY, @TYPES.CURRENT_DAY]
  @RANGE_TYPES: [@TYPES.DATE_RANGE, @TYPES.DATE_RANGE_UNTIL_NOW]

  removable: false

  getFilterType: =>
    @constructor.FILTER_TYPE

  isRealtime: =>
    @constructor.REALTIME_TYPES.includes(@values.type)

  isRange: =>
    @constructor.RANGE_TYPES.includes(@values.type)

  hasValues: =>
    @values.length != 0

  _valuesToJSON: =>
    @values
